import request from '@/utils/request'

let DiaryApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/diary.Diary/index', data, errorback);
  },

  /*审核*/
  audit(data, errorback) {
    return request._post('/shop/diary.Diary/audit', data, errorback);
  },
  
  /*删除*/
  del(data, errorback) {
    return request._post('/shop/diary.Diary/del', data, errorback);
  },

  /*设置模板变量*/
  setDetail(data, errorback) {
    return request._get('/shop/diary.Setting/index', data, errorback);
  },
  /*保存设置*/
  editSet(data, errorback) {
    console.log(data);
    return request._post('/shop/diary.Setting/index', data, errorback);
  },
  /*列表*/
  commentData(data, errorback) {
    return request._post('/shop/diary.Diary/comment', data, errorback);
  },
  /*评论审核*/
  commentAudit(data, errorback) {
    return request._post('/shop/diary.Diary/commentAudit', data, errorback);
  },
}
export default DiaryApi;



// WEBPACK FOOTER //
// ./src/api/diary.js